import { useState } from 'react';

import { Trans } from '@lingui/react/macro';

import { GenericError } from '../GenericError/GenericError';
import { MobileSignupFormProvider } from './form/MobileSignupFormProvider';
import { MobileSignupLayout } from './MobileSignupLayout/MobileSignupLayout';
import { SCREEN_REGISTRY } from './screens/registry';
import logger from '../../utils/logger';

const MobileSignupContainerDE = () => {
  // Placeholder index — 0.6 useMobileSignupNav replaces this (hash<->index, deep-link guard).
  const [index] = useState(0);

  // TODO(0.6): nav (onBack), direction-aware AnimatePresence, focus-to-heading.

  const screen = SCREEN_REGISTRY[index];
  const Content = screen?.Content;

  if (!screen || !Content) {
    logger.error('MobileSignup: no screen at index', {
      tags: { team: 'de-introducer' },
      index,
      registryLength: SCREEN_REGISTRY.length,
    });
    return <GenericError errorText={<Trans>Something went wrong.</Trans>} />;
  }

  // MobileSignupLayout (back + logo + progress) is rendered once here and stays
  // mounted across step changes; only Content swaps.
  return (
    <MobileSignupFormProvider>
      <div data-testid="mobile-signup-container">
        <MobileSignupLayout
          progress={{ current: index + 1, total: SCREEN_REGISTRY.length }}
        >
          <Content />
        </MobileSignupLayout>
      </div>
    </MobileSignupFormProvider>
  );
};

export default MobileSignupContainerDE;
